import { motion } from "framer-motion";
import SectionHeading from "./SectionHeading";
import { PRINCIPLES } from "../data/site";

export default function WhySefkam() {
  return (
    <section className="bg-[#F8FAFC] py-24 md:py-32" data-testid="why-sefkam-section">
      <div className="container-x">
        <SectionHeading eyebrow="Why SefKam?" title="Principles that shape how we build." max="max-w-2xl" />
        <div className="mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {PRINCIPLES.map((p, i) => (
            <motion.div
              key={p.n}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className="group rounded-3xl border border-slate-200 bg-white p-7 transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_30px_60px_-30px_rgba(7,17,31,0.2)]"
              data-testid={`principle-${i}`}
            >
              <span className="font-display text-5xl font-semibold tracking-tighter text-transparent [-webkit-text-stroke:1.4px_#07111F] transition-all duration-500 group-hover:[-webkit-text-stroke:1.4px_transparent] group-hover:accent-text">
                {p.n}
              </span>
              <h3 className="mt-6 font-display text-lg font-medium text-[#07111F]">{p.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-500">{p.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
